import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-order-shipments-summary',
  template: `
    <app-card-wrapper [removePanel]="true">
      <div class="insurance-container">
        <div class="insurance">
          <div class="insurance-info">
            <span translate>account.section.createConsignment.orderSummary.addon.insurance.title</span>
            <span translate>account.section.createConsignment.orderSummary.addon.insurance.info</span>
          </div>
        </div>
        <div class="buy-insurance">
          <mat-radio-group>
            <app-radio-field
              [value]="true"
              [checked]="selected"
              (handleChange)="handleInsuranceChange.emit($event.value)">
              <span translate>account.section.createConsignment.orderSummary.addon.insurance.checkboxYes</span>
            </app-radio-field>
            <app-radio-field
              [value]="false"
              [checked]="!selected"
              (handleChange)="handleInsuranceChange.emit($event.value)">
              <span translate>account.section.createConsignment.orderSummary.addon.insurance.checkboxNo</span>
            </app-radio-field>
          </mat-radio-group>
        </div>
      </div>
    </app-card-wrapper>
  `,
  styleUrls: ['./order-shipments-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class OrderShipmentsSummaryComponent {
  @Input() selected: boolean;
  @Output() handleInsuranceChange: EventEmitter<boolean> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/order-summary/components/order-shipments-summary/order-shipments-summary.component.ts